import { useState } from 'react';
import { sentence } from "shared/types/Report";
import useBatchView, { parseBatchLines } from './useBatchView';
import useStorage from "shared/hooks/useStorage";

const useSentenceBatchView = (list: sentence[], setList:React.Dispatch<React.SetStateAction<sentence[]>>, path:string, onCloseViewHandler:()=>void) => {
    const baseHook = useBatchView(list, setList, path);
    const {uploadStorage} = useStorage();
    const [fileList, setFileList] = useState<File[]>([]);
    const [audioList, setAudioList] = useState<File[]>([]);
    const [sentenceList, setSentenceList] = useState<string[]>([]);
    const [korList, setKorList] = useState<string[]>([]);

    const onChangeInputHandler = (name: string, value: string) => {
        const valueList = parseBatchLines(value);
        if(name === "sentence"){
            setSentenceList(valueList);
        }else if(name === "kor"){
            setKorList(valueList);
        }
    };

    const onRegisterReportClickHandler = async(list:sentence[]) => {
        try {
            const data = await registerImage(list);
            const audio = await registerAudio(data);
            const register_data = baseHook.removeKeyFromObjects(audio, "image_preview");
            await baseHook.onRegisterReportClick("sentence", register_data);
        } catch (error) {
            console.error("문장 일괄 등록 실패:", error);
            baseHook.setShowProgress(false);
            baseHook.openSaveFailedError();
        }
    }

    const registerImage = async(list:sentence[]) => {
        let newList = list;
        baseHook.setShowProgress(true);
        for(let i = 0; i < list.length; i++){
            const image = list[i].image;
            if (image instanceof File) {
                baseHook.setUploadFileName(image.name);
                const image_url = await uploadStorage(path + "/sentence", image, baseHook.setProgress).then(res => {
                    return res || "";
                })
                newList[i].image = image_url;
                newList[i].image_preview = "";
            }
        }
        baseHook.setShowProgress(false);
        setList(newList);
        return newList;
    }

    const registerAudio = async (list:sentence[]) => {
        let newList = list;
        baseHook.setShowProgress(true);
      
        for (let i = 0; i < list.length; i++) {
          const audio = audioList[i];
      
          if (audio) {
            baseHook.setUploadFileName(`audio-${i}.mp3`);
            const audio_url = await uploadStorage(
              path + "/sentence",
              audio,
              baseHook.setProgress
            ).then((res) => {
              return res || "";
            });
            newList[i].audio = audio_url;
          }
        }
      
        baseHook.setShowProgress(false);
        return newList;
    };

    const onSaveClickHandler = () => {
        if(!(sentenceList.length > 0 &&
            (sentenceList.length === korList.length || korList.length === 0) && 
            (sentenceList.length === fileList.length || fileList.length === 0) && 
            (sentenceList.length === audioList.length || audioList.length === 0))){
            baseHook.openCountMismatchError();
            return;
        }
        const newList:sentence[] = [];
        for(let i = 0; i < sentenceList.length; i++){
            newList.push({
                id:i + 1, 
                sentence:sentenceList[i] || "", 
                kor:korList[i] || "", 
                image:fileList[i] || "", 
                audio:""
            });
        }
        onRegisterReportClickHandler(newList);
    }

    const onSuccessModalConfirmHandler = () => {
        baseHook.onSuccessModalConfirmHandler();
        onCloseViewHandler();
    }

    return {
        ...baseHook, 
        fileList, 
        setFileList, 
        audioList,
        setAudioList,
        onChangeInputHandler, 
        onSaveClickHandler, 
        onSuccessModalConfirmHandler
    };
};

export default useSentenceBatchView;
